module.exports = __webpack_public_path__ + "static/media/imagePR.6ab03b88.webp";